module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Wood-horse-d9416e68423aea0b41c4d3bce86fddec.svg";